import { ApolloError } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { snackbar } from '@occc-app/design-system';
import { MessagingCampaignDetailsFragment } from '@occc/graphql';
import { getFormValues } from '@occc/ui-notifications';

import {
  breadcrumbLinks,
  CAMPAIGN_CREATE_SUCCESS_MESSAGE,
} from './messaging-campaign-create.constants';
import { useMessagingCampaignCreatePageController } from './use-messaging-campaign-create-controller.hook';
import { MessagingCampaignCreatePage } from './messaging-campaign-create.page';

import { routeCreator } from '../../messaging-center.utils';
import { MessagingCampaignTabs } from '../messaging-campaign-configure/messaging-campaign-configure.constants';
import { GENERAL_ERROR_MESSAGE } from '../../messaging-center.constants';

export const MessagingCampaignCreatePageContainer = () => {
  const navigate = useNavigate();

  const onCompleted = ({ campaign }: { campaign: MessagingCampaignDetailsFragment }) => {
    navigate(routeCreator.campaignConfigureWithTab(campaign.uuid, MessagingCampaignTabs.Target));
    snackbar.success(CAMPAIGN_CREATE_SUCCESS_MESSAGE);
  };

  const { handleSubmit, isLoading } = useMessagingCampaignCreatePageController({
    onCompleted,
    onError: (error: ApolloError) => {
      snackbar.error(GENERAL_ERROR_MESSAGE);
      console.error(error);
    },
  });

  const handleCancelClick = () => {
    navigate(routeCreator.campaignsList());
  };

  return (
    <MessagingCampaignCreatePage
      breadcrumbLinks={breadcrumbLinks}
      isLoading={isLoading}
      configureFormProps={{
        onSubmit: handleSubmit,
        loading: isLoading,
        initialValues: {
          ...getFormValues(),
          title: '',
          description: '',
        },
        onCancelClick: handleCancelClick,
        isUserPermittedToEdit: true,
      }}
    />
  );
};
